import script from "./ComposeMessageDialog.vue?vue&type=script&setup=true&lang=js"
export * from "./ComposeMessageDialog.vue?vue&type=script&setup=true&lang=js"

import "./ComposeMessageDialog.vue?vue&type=style&index=0&id=6af7dfa7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6af7dfa7"]])

export default __exports__